/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ArrayOfByte } from '../arrayOfByte.schema';

export const MonthlyCoveragePlanSummaryDto = zod.object({
  "id": zod.string().uuid().optional(),
  "changeRequestId": zod.string().uuid().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "monthId": zod.number().optional(),
  "monthName": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "year": zod.number().optional(),
  "areaName": zod.string().optional(),
  "remarks": zod.string().optional(),
  "isDeleted": zod.boolean().optional(),
  "timestamp": zod.lazy(() => ArrayOfByte).optional()
});

export type MonthlyCoveragePlanSummaryDto = zod.input<typeof MonthlyCoveragePlanSummaryDto>;
export type MonthlyCoveragePlanSummaryDtoOutput = zod.output<typeof MonthlyCoveragePlanSummaryDto>;
